<template>
  <div class="relative w-full overflow-x-hidden">
    <!-- Breadcrumb (solo se muestra cuando no está en la raíz) -->
    <navigation-breadcrumb
      :items="breadcrumbItems"
      @back="_handleBreadcrumbClick(-1)"
      @item-click="_handleBreadcrumbClick"
    />

    <!-- Contenido de navegación con transición -->
    <list-items-view
      :items-list="itemsList"
      :current-item="currentItem"
      @item-click="_handleItemClick"
      @go-back="_goBack"
      @detail-item-click="_handleDetailItemClick"
      @epc-pictograms-reload="$emit('epc-pictograms-reload')"
    />
  </div>
</template>

<script>
import NavigationBreadcrumb from './navigation-breadcrumb.vue';
import ListItemsView from './list-items-view.vue';

export default {
  name: 'ListNavigationView',

  components: {
    NavigationBreadcrumb,
    ListItemsView,
  },

  props: {
    items: {
      type: Array,
      required: true
    },
  },

  data() {
    return {
      internalItems: [], // Copia de los items para evitar mutaciones directas
      navigationStack: [], // Stack de navegación para breadcrumb dinámico
    };
  },

  watch: {
    items: {
      immediate: true,
      deep: true,
      handler(newItems) {
        // Resetear la navegación al cambiar los items
        this.navigationStack = [];
        // Clonamos los items para evitar mutaciones directas
        this.internalItems = newItems.map(item => ({
          ...item
        }));
      }
    }
  },

  computed: {
    breadcrumbItems() {
      // Retornar todos los items del stack para mostrar en el breadcrumb
      return this.navigationStack;
    },

    itemsList() {
      // Si hay navegación, mostrar los children del último item del stack
      if (this.navigationStack.length > 0) {
        const lastNav = this.navigationStack[this.navigationStack.length - 1];
        return lastNav.children || [];
      }
      // Si no hay navegación, mostrar los items iniciales
      return this.internalItems;
    },

    currentItem() {
      // Obtener el item actual desde el último elemento del stack
      const lastNav = this.navigationStack[this.navigationStack.length - 1];
      return lastNav || null;
    }
  },

  methods: {
    _handleItemClick(item) {
      // Agregar al stack de navegación el item completo con su información
      this.navigationStack.push(item);
    },

    _goBack() {
      if (this.navigationStack.length > 1) {
        // Si hay más de un nivel, retroceder un nivel
        this.navigationStack.pop();
      } else {
        // Si solo hay un nivel, volver a la raíz
        this.navigationStack = [];
      }
    },

    _handleBreadcrumbClick(index) {
      if (index === -1) {
        // Click en "Volver" - retroceder un nivel
        this._goBack();
      } else {
        // Click en un item del breadcrumb - navegar a ese nivel
        this.navigationStack = this.navigationStack.slice(0, index + 1);
      }
    },

    _handleDetailItemClick(item) {
      // Emitir el evento para que el componente padre pueda manejar la navegación
      this.$emit('item-click', item, this.currentItem);
    },

    resetNavigation() {
      this.navigationStack = [];
    }
  }
}
</script>

